import tootip from '@/assets/icon/minimap/Tooltip.svg';
import { body2, palette } from '@/modules/defines/styles';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as I from '@/assets/icon/signs/index';
const Icons = [
  {
    id: 1,
    title: '에스컬레이터',
    icon: I.escalator,
  },
  {
    id: 2,
    title: '엘리베이터',
    icon: I.elevator,
  },

  {
    id: 3,
    title: '계단',
    icon: I.stairs,
  },
  {
    id: 4,
    title: '화장실',
    icon: I.toilet,
  },
  {
    id: 5,
    title: '장애인화장실',
    icon: I.disabled,
  },

  {
    id: 6,
    title: '기저귀교환대',
    icon: I.baby,
  },
  {
    id: 7,
    title: '주차장',
    icon: I.parking,
  },
];
const ToolTipList = () => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    document.body.addEventListener('click', () => {
      setToggle(false);
    });
  }, [toggle]);
  return (
    <Relative>
      <Wrapper
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setToggle(!toggle);
        }}
      >
        <img src={tootip} alt="Interactive" />
      </Wrapper>
      <List $isShow={toggle}>
        {Icons.map((icon) => (
          <Item key={icon.id}>
            <img
              width={24}
              height={24}
              loading="lazy"
              src={icon.icon}
              alt={icon.title}
            />
            {icon.title}
          </Item>
        ))}
      </List>
    </Relative>
  );
};

const Relative = styled.div`
  position: relative;
`;

const Wrapper = styled.button`
  display: flex;
  align-items: center;
`;

const List = styled.ul<{ $isShow: boolean }>`
  color: white;
  ${body2};
  border-radius: 12px;
  position: absolute;
  display: ${({ $isShow }) => ($isShow ? 'flex' : 'none')};
  flex-direction: column;
  gap: 0.75rem;
  width: 11rem;

  padding: 1.25rem 1.5rem;
  background: ${palette.opacityBlack80};
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export default ToolTipList;
